var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4C0 28.9933 2.96 32 6.6 32H25.4067C29.0467 31.9933 32 29.04 32.0067 25.4V6.6C32.0067 3.00667 29.0467 0 25.4067 0H6.6C3 0 0 2.96 0 6.6V25.4067V25.4Z",
    fill: "#FA536C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7197 7.17335C17.9664 8.03335 16.7797 8.78668 15.5931 8.68002C15.3797 7.38668 16.0264 6.09335 16.6731 5.34002C17.4264 4.37335 18.7197 3.72668 19.7997 3.72668C19.9064 4.91335 19.4797 6.20668 18.7197 7.17335ZM19.7997 8.89335C20.4464 8.89335 22.3864 9.10668 23.6797 11.0467C23.5731 11.1534 21.4197 12.4467 21.4197 15.14C21.4197 18.3734 24.2197 19.4534 24.2197 19.4534C24.2197 19.56 23.7864 20.96 22.8197 22.4734C21.9597 23.7667 20.9864 25.06 19.5864 25.06C18.1864 25.06 17.7531 24.2 16.1397 24.2C14.5264 24.2 13.9864 25.06 12.6931 25.06C11.2931 25.06 10.2131 23.66 9.35307 22.3667C7.51974 19.6734 6.11974 14.82 8.05974 11.5867C8.91974 9.97335 10.6464 8.89335 12.3731 8.89335C13.7731 8.89335 15.0664 9.86002 15.8197 9.86002C16.5731 9.86002 18.0797 8.78002 19.8064 8.89335H19.7997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.8246dd9c9a34e080471857dce6326adc.svg";
export { ForwardRef as ReactComponent };